import { useStepsCarousel } from '@/hooks/useStepsCarousel';
import { ViewObserver } from '@montugroup/design-system';
import { Grid2, useMediaQuery, useTheme } from '@mui/material';
import { StepsCarouselImages } from './StepsCarouselImages';
import { StepsCarouselSteps } from './StepsCarouselSteps';

export type StepContent = {
  stepNumber: number;
  stepText: string;
};

export type Step = StepContent & {
  stepImage: string;
};

export type StepsCarouselProps = {
  titleMobile: React.ReactNode;
  titleDesktop: React.ReactNode;
  subtitle: string;
  steps: Step[];
};

export function StepsCarousel({ titleMobile, titleDesktop, subtitle, steps }: StepsCarouselProps) {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('md'));

  const { activeStep, stepsContent, stepsAssets, play, reset, onStepClick } = useStepsCarousel({
    steps,
    intervalMs: 3000,
    initialStep: 0,
  });

  return (
    <Grid2
      container
      spacing={10}
      direction={{ xs: 'column-reverse', md: 'row' }}
      justifyContent={{ md: 'space-between' }}
      alignItems={{ md: 'center' }}
      columns={{ xs: 1, md: 2 }}
      width="100%"
      margin={0}
    >
      <ViewObserver
        id="onboarding-steps"
        onEnter={play}
        onExit={reset}
        debounceMS={50}
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: isMobileView ? 'column-reverse' : 'row',
        }}
      >
        <StepsCarouselSteps
          title={titleDesktop}
          subtitle={subtitle}
          steps={stepsContent}
          activeStep={activeStep}
          onStepClick={onStepClick}
        />
        <StepsCarouselImages title={titleMobile} subtitle={subtitle} stepImages={stepsAssets} activeStep={activeStep} />
      </ViewObserver>
    </Grid2>
  );
}
